import axios, {AxiosRequestConfig} from "axios";
import {OidcProviderInfo} from "../model";
import {getContextPath} from "../paths";

let oidcProviderInfo: OidcProviderInfo;
export const startOidcProvider = async (): Promise<OidcProviderInfo> => {
  const baseUrl = getContextPath().replace("/studio", "");
  const urlToConfig = baseUrl + "/actuators/apolloConfig";
  oidcProviderInfo = {
    clientId: "",
    authorizationEndpoint: "",
    tokenEndpoint: "",
    logoutEndpoint: "",
    redirectUri: "",
    scope: "",
    issuer: "",
    jwkSetEndpoint: "",
    userInfoEndpoint: "",
    enabled: false
  };
  const init: AxiosRequestConfig = {
    method: "GET",
    headers: {'Content-Type': 'application/json'}
  };
  try {
    const response = await axios.get(urlToConfig, init);
    oidcProviderInfo = response.data;
    return oidcProviderInfo;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return oidcProviderInfo;
    }
  }
};
export {oidcProviderInfo};
